var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('a-spin',{attrs:{"spinning":_vm.loading,"tip":"页面加载中..."}}),_c('iframe',{ref:"Iframe",class:_vm.$style.iframe,attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }